import React from "react";
import { Container } from "react-bootstrap";
import { LoginHeader, Breadcrumb, ImageElement } from "../../components";

function Notification() {
    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Notification',
        },
    ];
    return (
        <>       
            <LoginHeader/>
            <main className="notifiPage">
                <Container className="notifiPage_inner">
                    <Breadcrumb title="Notifications" breadcrumb={breadcrumb}/>
                    <div className="notifiPage_box p-30">
                        <div className="notifiPage_box_items">
                            <h2>Today</h2>
                            <div className="notifiPage_box_list">
                                <h3>David has finished the job and is ready for payment. HVAC Cristy hopper kam  83928338.</h3>
                                <p className="d-flex align-items-center mb-0"><em className="gg-calendar me-1"/> Thu, March 3, 2022 at 8:00 AM</p>
                            </div>
                            <div className="notifiPage_box_list">
                                <h3>Service Provider kam test is arrived. Cristy hopper kam 1443252269.</h3>
                                <p className="d-flex align-items-center mb-0"><em className="gg-calendar me-1"/> Thu, March 3, 2022 at 8:00 AM</p>
                            </div>
                            <div className="notifiPage_box_list">
                                <h3>Good Guys Service Provider Smith Provider  has Accepted the service request. Cristy hopper Smith Provider  918770713907.</h3>
                                <p className="d-flex align-items-center mb-0"><em className="gg-calendar me-1"/> Thu, March 3, 2022 at 8:00 AM</p>
                            </div>
                        </div>
                        <div className="notifiPage_box_items">
                            <h2>Yesterday</h2>
                            <div className="notifiPage_box_list">
                                <h3>David has finished the job and is ready for payment. HVAC Cristy hopper kam  83928338.</h3>
                                <p className="d-flex align-items-center mb-0"><em className="gg-calendar me-1"/> Thu, March 2, 2022 at 8:00 AM</p>
                            </div>
                            <div className="notifiPage_box_list">
                                <h3>Service Provider kam test is arrived. Cristy hopper kam 1443252269.</h3>
                                <p className="d-flex align-items-center mb-0"><em className="gg-calendar me-1"/> Thu, March 2, 2022 at 8:00 AM</p>
                            </div>
                        </div>
                        <div className="notifiPage_box_items">
                            <h2>This Week</h2>
                            <div className="notifiPage_box_list">
                                <h3>David has finished the job and is ready for payment. HVAC Cristy hopper kam  83928338.</h3>
                                <p className="d-flex align-items-center mb-0"><em className="gg-calendar me-1"/> Thu, March 2, 2022 at 8:00 AM</p>
                            </div>
                        </div>
                        {/* EMPTY SCREEN_______ */}
                            {/* <div className="notifiPage_box_items">
                                <div className="noList m-auto text-center d-flex align-items-center justify-content-center">
                                    <div className="noList_inner">
                                        <ImageElement source="notification-icon.svg" className="img-fluid"/>
                                        <div className="noList_cnt">
                                            <h5>No Notification</h5>
                                            <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                        </div>
                                    </div>                                
                                </div>
                            </div> */}

                    </div>
                </Container>
            </main>
        </>
    );
  }
  
  export default Notification;